import { Platform, StyleSheet } from 'react-native';
import { pick } from 'lodash';
import { useSelector } from 'react-redux';

import { appInfoSelector } from '@common/redux/selectors/app';
import { checkFont } from '../func';
import { AppVersion } from 'click-types';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style || {};

  const getShadow = () => {
    if (!attributes.shadow) return {};

    return {
      shadowColor: attributes.shadow.color,
      shadowRadius: attributes.shadow.size,
      shadowOpacity: attributes?.shadow?.blur || 0,
      shadowOffset: {
        width: attributes.shadow.x,
        height: attributes.shadow.y,
      },
      elevation:
        attributes?.shadow?.size === 0
          ? attributes?.shadow?.x
          : attributes?.shadow?.size,
    };
  };

  const getFontWeight = () => {
    if (!attributes.fontWeight) return 'normal';

    return typeof attributes.fontWeight === 'string'
      ? attributes.fontWeight
      : attributes.fontWeight.toString();
  };

  let { backgroundColor, borderRadius, color, height, width } = attributes;

  if (isV4) {
    color = style?.color;
    backgroundColor = style?.backgroundColor;
    borderRadius = style?.borderRadius;
    width = style?.width;
    height = style?.height;
  }

  // Commonly reused derived values
  const borderStyleValue = style?.borderStyle || attributes.borderStyle;
  const borderWidthValue = style?.borderWidth || attributes.borderWidth;
  const borderColorValue = style?.borderColor || attributes.borderColor;
  const fontSizeValue = style?.fontSize ?? attributes.fontSize;
  const paddingValue = style?.padding ?? attributes.padding;
  const colorValue = style?.color ?? attributes.color;

  return StyleSheet.create({
    container: {
      ...pick(attributes, ['marginTop', 'marginLeft']),
      ...(style?.marginTop !== undefined && {
        marginTop: style.marginTop,
      }),
      ...(style?.marginLeft !== undefined && {
        marginLeft: style.marginLeft,
      }),
      width,
      height,
      zIndex: attributes.zIndex,
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
        ])),
    },
    wrapper: {},
    text: {
      backgroundColor,
      borderRadius,
      color,
      // ...(attributes?.shadow?.size > 0 ? getShadow() : {}),
      fontWeight: getFontWeight(),
      fontFamily: checkFont(attributes.fontFamily),
      textAlign: attributes.textAlignment,
      ...pick(attributes, [
        // 'fontSize',
        'padding',
        'opacity',
      ]),
      fontSize:
        fontSizeValue < 13 && attributes.multiline === true
          ? fontSizeValue * 1.15
          : fontSizeValue,
      ...(attributes.borderStyle !== 'none'
        ? pick(attributes, ['borderWidth', 'borderColor'])
        : {}),
      ...(colorValue !== undefined && { color: colorValue }),
      ...(paddingValue !== undefined && { padding: paddingValue }),
      ...(style?.opacity !== undefined && { opacity: style.opacity }),
      ...(borderStyleValue !== 'none'
        ? {
            borderWidth: borderWidthValue,
            borderColor: borderColorValue,
          }
        : {}),
      borderStyle: borderStyleValue === 'none' ? 'solid' : borderStyleValue,
      minHeight: height,
      width,
      ...getShadow(),
      paddingLeft: paddingValue || 10,
      display: 'flex',
      ...Platform.select({
        ios: {
          paddingTop: attributes?.multiline
            ? attributes?.height < attributes?.fontSize * 1.15 + 10
              ? 0
              : 10
            : 0,
          paddingBottom: attributes?.multiline
            ? attributes?.height < attributes?.fontSize * 1.15 + 20
              ? 0
              : 10
            : 0,
        },
        android: {
          paddingTop: 0,
          paddingBottom: 0,
          includeFontPadding: attributes?.multiline ? true : false,
        },
        web: {
          maxHeight: height,
        },
      }),
    },
    icon: {
      position: 'absolute',
      right: 10,
    },
  });
};

export default createStyles;
